export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";